import { getCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

import { COOKIE_EMBED_NAME } from 'constants/embed.constants';

// Use state to ensure that we apply our layout changes after the initial render
// This way we prevent SSR issues
export const useEmbedded = () => {
  const [isEmbedded, setIsEmbedded] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setIsEmbedded(!!getCookie(COOKIE_EMBED_NAME));
  }, []);

  return { isEmbedded, isLoaded: isEmbedded !== undefined };
};
